const color = "#15749D";
const hoverColor = "#116285";
const activeColor = "#0E506D";

export const fallbackValues = {
  color,
  hoverColor,
  activeColor
};
